import React from 'react';
import {translate} from 'react-i18next';
import * as query from '../helpers/query';
import * as photosService from '../services/photos';
import Header from '../Header';
import InformationModal from '../modals/InformationModal';
import PhotoView from '../PhotoView';
import UserModal from '../modals/UserModal';
import UserPhotoLibrary from '../UserPhotoLibrary';
import Snackbar from '../Snackbar';

const ACTIVE_PHOTO = Symbol();

class Manage extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            photos: [],
            showInformationModal: false,
            showUserModal: false,
        };

        this.handleActivePhotoChange = this.handleActivePhotoChange.bind(this);
        this.handleDeletePhoto = this.handleDeletePhoto.bind(this);
        this.handleInformationClick = this.handleInformationClick.bind(this);
        this.handleInformationModalClose = this.handleInformationModalClose.bind(this);
        this.handlePhotoViewClose = this.handlePhotoViewClose.bind(this);
        this.handlePhotoViewOpen = this.handlePhotoViewOpen.bind(this);
        this.handleUserClick = this.handleUserClick.bind(this);
        this.handleUserModalClose = this.handleUserModalClose.bind(this);
    }

    componentDidMount() {

        this.fetchData();
    }

    fetchData() {

        photosService.getByParameters({myphotos: true})
            .then(result => result.items)
            .then(photos => {

                this.setState({photos});

                if (photos.length === 0)
                    Snackbar.show({message: this.props.t('manage.noPhotos')});
            });
    }

    getActivePhoto(state = this.state) {

        const params = new URLSearchParams(this.props.location.search);
        const activePhotoId = params.has('activePhoto') ? Number(params.get('activePhoto')) : null;

        if (!activePhotoId) {

            this[ACTIVE_PHOTO] = null;
        }
        else if ((this[ACTIVE_PHOTO] || {}).id !== activePhotoId) {

            this[ACTIVE_PHOTO] = state.photos.find(photo => photo.id === activePhotoId);
        }

        return this[ACTIVE_PHOTO];
    }

    getFullScreen() {

        return ['true', '1'].includes(new URLSearchParams(this.props.location.search).get('fullScreen'));
    }

    handleActivePhotoChange(photo) {

        this.setQueryParameters({activePhoto: photo.id});
    }

    handleDeletePhoto(photo) {

        this.setState((prevState, props) => ({

            photos: prevState.photos.filter(x => x !== photo),
        }));

        this.setQueryParameters({activePhoto: undefined});
    }

    handleInformationClick() {

        this.setState({showInformationModal: true});
    }

    handleInformationModalClose() {

        this.setState({showInformationModal: false});
    }

    handlePhotoViewClose() {

        this.setQueryParameters({fullScreen: false});
    }

    handlePhotoViewOpen(photo) {

        this.setQueryParameters({activePhoto: photo.id, fullScreen: true});
    }

    handleUserClick() {

        this.setState({showUserModal: true});
    }

    handleUserModalClose() {

        this.setState({showUserModal: false});
    }

    render() {

        return (

            <div className="d-flex flex-column">

                <Header embedControl={false}
                        filterControl={false}
                        onInformationClick={this.handleInformationClick}
                        onUserClick={this.handleUserClick}/>

                <div className="container-fluid d-flex flex-column py-3">
                    <UserPhotoLibrary photos={this.state.photos} onPhotoViewOpen={this.handlePhotoViewOpen}/>
                </div>

                {(this.getFullScreen() && this.getActivePhoto()) && <PhotoView photos={this.state.photos}
                                                                               activePhoto={this.getActivePhoto()}
                                                                               onActivePhotoChange={this.handleActivePhotoChange}
                                                                               onClose={this.handlePhotoViewClose}
                                                                               onDeletePhoto={this.handleDeletePhoto}/>}

                <InformationModal show={this.state.showInformationModal} onClose={this.handleInformationModalClose}/>
                <UserModal show={this.state.showUserModal} onClose={this.handleUserModalClose}/>

            </div>
        );
    }

    setQueryParameters(params) {

        const current = new URLSearchParams(this.props.location.search);

        const queryActivePhoto = current.has('activePhoto') ? Number(current.get('activePhoto')) : undefined;
        const queryFullScreen = ['true', '1'].includes(current.get('fullScreen'));

        // We shouldn't update the URL unnecessarily, as it might trigger unexpected route props to update, triggering an infinite component update loop.

        if (queryActivePhoto !== params.activePhoto || queryFullScreen !== params.fullScreen) {

            this.props.history.push({

                search: query.buildQueryString(Object.assign({

                    activePhoto: queryActivePhoto,
                    fullScreen: queryFullScreen,

                }, params)),
            });
        }
    }
}

export default translate()(Manage);



// WEBPACK FOOTER //
// ./src/components/pages/Manage.js